import { AccountLayout } from "features/account/AccountLayout";
import i18n from "i18n/config";
import { Navigate, RouteObject } from "react-router-dom";

export const accountRoutes: RouteObject = {
  id: "account",
  path: "account",
  element: <AccountLayout />,
  children: [
    {
      id: "accountProfile",
      path: "",
      element: <Navigate to="security" replace={true} />,
      handle: {
        title: i18n.t("account:profile.title"),
        isDisabled: true,
        isHidden: true,
      },
    },
    {
      id: "accountSecurity",
      path: "security",
      lazy: async () => {
        const { AccountSecurityPage } = await import(
          "features/account/AccountSecurityPage"
        );
        return { Component: AccountSecurityPage };
      },
      handle: {
        title: i18n.t("account:security.title"),
      },
    },
  ],
};
